// extracted by mini-css-extract-plugin
var _1 = "RequestProfileHeaderFooterSkeleton-modulebar__LDNnc";
var _2 = "RequestProfileHeaderFooterSkeleton-modulefooter__BWzPG RequestProfileHeaderFooter-modulefooter__qZVAB";
export { _1 as "bar", _2 as "footer" }
